module.exports = __webpack_public_path__ + "img/paper-airplane-icon.3d6fe132.svg";